import {Helpers} from "../../../services/Helpers";
import Web3Connection from "../../../services/web3Connection";

// https://web3js.readthedocs.io/en/v1.2.6/web3-net.html
// https://wiki.parity.io/JSONRPC-net-module
// https://nethermind.readthedocs.io/en/latest/jsonrpc.html

const FETCH_STATUS = {
    INITIAL: 0,
    PENDING: 1,
    OK: 2,
    FAILED: 3,
}

export default {
    name: 'node-info',
    template: require('./NodeInfo.html'),
    data() {
        return {
            rpcUrl: '',
            // rpcUrl: 'https://server.yalland.com:8645/',
            // rpcUrl: 'ws://sokol-rpc-parity-001.poa.network:8546',
            // rpcUrl: 'https://sokol-archive.blockscout.com/',
            // rpcUrl: 'wss://kovan.infura.io/ws/v3/83ea24ff57c3420abe37f03312bbafc1',
            // rpcUrl: 'https://kovan.infura.io/v3/83ea24ff57c3420abe37f03312bbafc1',
            // rpcUrl: 'http://sokol-rpc-parity-001.poa.network:8545/',
            // rpcUrl: 'https://dai.poa.network/'
            fetchStatus: FETCH_STATUS.INITIAL,
            infoGetNodeInfo: '',
            infoGetProtocolVersion: '',
            infoNetGetId: '',
            infoNetIsListening: '',
            infoNetGetPeerCount: '',
            infoIsSyncing: '',
            infoIsMining: '',
            infoGetHashrate: '',
            infoGetChainId: '',
            infoGetBlockNumber: '',
            infoGetGasPrice: '',
            infoGetAccounts: '',
            nodeError: '',
            link: ''
        }
    },
    validations: {
    },
    created() {
        const target = this.$parseQuery.get('target');

        if (target === 'ec-recover') {
            this.input = this.$parseQuery.get('ec-recover-input');
            this.signature = this.$parseQuery.get('ec-recover-signature');
        }

        if (localStorage.latestNodeUrl && localStorage.latestNodeUrl.length > 0) {
            this.rpcUrl = localStorage.latestNodeUrl;
        }
        this.fetchInfo();
    },
    methods: {
        async fetchInfo() {
            const url = this.rpcUrl.trim();
            this.fetchStatus = FETCH_STATUS.PENDING;

            this.infoGetNodeInfo = '';
            this.infoGetProtocolVersion = ''
            this.infoGetChainId = '';
            this.infoNetGetId = '';
            this.infoNetIsListening = '';
            this.infoNetGetPeerCount = '';
            this.infoIsSyncing = '';
            this.infoIsMining = '';
            this.infoGetHashrate = '';
            this.infoGetBlockNumber = '';
            this.infoGetGasPrice = '';
            this.infoGetAccounts = '';

            if (url === "") {
                this.fetchStatus = FETCH_STATUS.INITIAL;
            } else {
                try {
                    await Web3Connection.reconnect(url);
                } catch (e) {
                    this.fetchStatus = FETCH_STATUS.FAILED;
                    this.nodeError = e;
                    return;
                }

                localStorage.latestNodeUrl = url;

                this.fetchStatus = FETCH_STATUS.OK;

                await Web3Connection.execute(async web3 => {
                    this.infoGetNodeInfo = await web3.eth.getNodeInfo();
                    this.infoGetProtocolVersion = await web3.eth.getProtocolVersion();
                    this.infoGetChainId = await web3.eth.getChainId();

                    // web3.eth.net
                    this.infoNetGetId = await web3.eth.net.getId();
                    this.infoNetIsListening = await web3.eth.net.isListening();
                    this.infoNetGetPeerCount = await web3.eth.net.getPeerCount();

                    this.infoIsSyncing = await web3.eth.isSyncing()
                    this.infoIsMining = await web3.eth.isMining()
                    this.infoGetHashrate = await web3.eth.getHashrate()

                    this.infoGetBlockNumber = await web3.eth.getBlockNumber()
                    this.infoGetGasPrice = await web3.eth.getGasPrice()

                    this.infoGetAccounts = await web3.eth.getAccounts()
                })
            }
        },
        copyLink(e) {
            e.preventDefault();

            console.log('🔗', this.link);

            Helpers.copyToClipboard(this.link);
        }
    }
}
